<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Scan Provider</h1>

    <kendo-grid
      class="mt-3"
      [data]="gridView"
      [group]="groups"
      [sortable]="true"
      [sort]="sort"
      (sortChange)="onSortChange($event)"
      [resizable]="true"
      >
      <ng-template kendoGridNoRecordsTemplate>
        <app-grid-no-records></app-grid-no-records>
      </ng-template>

      <ng-template kendoGridToolbarTemplate>
        <button class="btn btn-primary ms-auto" [routerLink]="['/scan-provider-edit']" i18n>
          Scan Provider hinzufügen
        </button>
      </ng-template>

      <kendo-grid-column field="customerName" i18n-title title="Kunde" [hidden]="true">
        <ng-template kendoGridGroupHeaderTemplate let-value="value" let-group="group">
          <strong>{{ value }}</strong>
          <span class="ms-1 text-muted">({{ group.items.length }})</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="providerKey" i18n-title title="Provider"></kendo-grid-column>
      <kendo-grid-column field="isEnabled" i18n-title title="Aktiv" [width]="90">
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.isEnabled) {
            <span class="badge bg-success" i18n>Aktiv</span>
          } @else {
            <span class="badge bg-secondary" i18n>Inaktiv</span>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="cadenceMinutes" i18n-title title="Intervall (Min.)" [width]="130"></kendo-grid-column>
      <kendo-grid-column field="lastRunAt" i18n-title title="Letzter Lauf" format="{0:g}" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="nextRunAt" i18n-title title="Nächster Lauf" format="{0:g}" [width]="150"></kendo-grid-column>

      <kendo-grid-command-column title="" [width]="290" [resizable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-end gap-2">
            <button
              kendoGridEditCommand
              type="button"
              i18n-title
              title="Bearbeiten"
              [routerLink]="['/scan-provider-edit', dataItem.id]"
              >
              <i><fa-icon [icon]="faEdit"></fa-icon></i>
            </button>
            <button
              kendoGridEditCommand
              type="button"
              i18n-title
              title="Scan-Läufe anzeigen"
              [routerLink]="['/scan-provider-runs', dataItem.id]"
              >
              <i><fa-icon [icon]="faHistory"></fa-icon></i>
            </button>
            <button
              kendoGridEditCommand
              type="button"
              i18n-title
              title="Aktivieren/Deaktivieren"
              [asyncClick]="onToggleEnabled(dataItem)"
              [disabled]="toggleBtn.disabled"
              #toggleBtn="asyncClick"
              >
              <i>
                @if (toggleBtn.busy) {
                  <span class="spinner-border spinner-border-sm"></span>
                } @else {
                  <fa-icon [icon]="dataItem.isEnabled ? faToggleOn : faToggleOff"></fa-icon>
                }
              </i>
            </button>
            <button
              kendoGridEditCommand
              type="button"
              i18n-title
              title="Scan jetzt starten"
              [asyncClick]="onTriggerNow(dataItem)"
              [disabled]="triggerBtn.disabled || isRunPending(dataItem)"
              #triggerBtn="asyncClick"
              >
              <i>
                @if (triggerBtn.busy || isRunPending(dataItem)) {
                  <span class="spinner-border spinner-border-sm"></span>
                } @else {
                  <fa-icon [icon]="faPlay"></fa-icon>
                }
              </i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger"
              i18n-title
              title="Löschen"
              [asyncClick]="onDelete(dataItem)"
              [disabled]="deleteBtn.disabled"
              #deleteBtn="asyncClick"
              >
              <i>
                @if (deleteBtn.busy) {
                  <span class="spinner-border spinner-border-sm"></span>
                } @else {
                  <fa-icon [icon]="faTrashAlt"></fa-icon>
                }
              </i>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
